import { useEffect } from "react";
import { useLocation } from "react-router";

const ScrollToTop = () => {
  // Extracts pathname property(key) from an object
  const { pathname, hash } = useLocation();
  
  useEffect(() => {
    const id = hash ? hash.replace("#", "") : "";
    const element = id ? document.getElementById(id) : null;

    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    } else {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
